<template>
    <div class="oc-modal-button-holder">
        <slot name="button">
            <oc-button v-bind="$_button" v-class="$_button.class" @click="show = true" />
        </slot>
        <oc-modal :show="show" v-bind="$attrs" v-on="modalEvents">
            <slot></slot>
        </oc-modal>
    </div>
</template>
<script>
import {addEvent} from '@/helpers/Utils'

export default {
    name: 'oc-modal-button',
    inheritAttrs: false,
    props: {
        button: {
            type: [Object, String],
            default: '...'
        }
    },
    computed: {
        $_button() {
            if( typeOf(this.button) === 'string' ) {
                return {
                    text: this.button,
                    type: 'primary'
                }
            }
            return this.button
        },
        modalEvents() {
            let listeners = Object.assign({}, this.$listeners)

            let closeModal = function () {
                this.show = false
            }.bind(this)

            listeners = addEvent(listeners, 'close', closeModal)
            listeners = addEvent(listeners, 'confirm', closeModal)

            return listeners
        }
    },
    data() {
        return {
            show: false
        }
    }
}
</script>
